import React from 'react';
import { useWatch } from 'react-hook-form';
import CardsAccepted from '../CardsAccepted';
import CardInformation from '../CardInformation';
import ACHInformation from '../ACHInformation';
import DebitCardInformation from '../DebitCardInformation';
import { makeFieldsRequired } from '../MoveIn/reducer';

const PaymentDetails = ({ step }) => {
  const { paymentType } = useWatch();

  if (paymentType === 'credit') {
    makeFieldsRequired({ stepModifiers: { paymentType: {
      credit: true,
      debit: false,
      ach: false,
    } },
    step });

    return (
      <>
        <CardsAccepted />
        <CardInformation />
      </>
    );
  }

  if (paymentType === 'debit') {
    makeFieldsRequired({ stepModifiers: { paymentType: {
      credit: false,
      debit: true,
      ach: false,
    } },
    step });
    return (
      <>
      <CardsAccepted />
      <DebitCardInformation />
      </>
    );
  }

  if (paymentType === 'ach') {
    makeFieldsRequired({ stepModifiers: { paymentType: {
      credit: false,
      debit: false,
      ach: true,
    } },
    step });
    return <ACHInformation />;
  }

  return null; // fallback in case of an unknown type
};

export default PaymentDetails;
